import type { JSX } from 'react';
import { Link } from "react-router-dom";

export default function PrivacyPolicy(): JSX.Element {
  return (
    <main className="max-w-4xl mx-auto py-12 px-4 text-white">
      <div className="mb-6">
        <Link to="/" className="text-white hover:text-white/90 underline-offset-4 hover:underline">
          ← Grįžti į pradžią
        </Link>
      </div>

      <h1 className="text-2xl font-bold mb-4">Privatumo politika</h1>
      <p className="mb-4">Ši privatumo politika aprašo, kaip mes renkame, naudojame ir saugome jūsų asmens duomenis naudojant KITM Wordcloud paslaugą.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Duomenų rinkimas</h2>
      <p className="mb-2">Mes galime rinkti jūsų pateiktą informaciją, tokią kaip vardas, el. pašto adresas ir pateikti žodžiai ar pateikimai.</p>

      <h2 className="text-xl font-semibold mt-4 mb-2">2. Naudojimo tikslas</h2>
      <p className="mb-2">Surinktą informaciją naudojame paslaugos teikimui, techninei priežiūrai ir aptarnavimui, taip pat siekiant užkirsti kelią piktnaudžiavimui.</p>

      <h2 className="text-xl font-semibold mt-4 mb-2">3. Duomenų saugojimas</h2>
      <p className="mb-2">Duomenys saugomi tik tiek, kiek reikia šiems tikslams įgyvendinti arba tiek, kiek reikalauja teisės aktai.</p>

      <h2 className="text-xl font-semibold mt-4 mb-2">4. Jūsų teisės</h2>
      <p className="mb-2">Turite teisę susipažinti su savo duomenimis, juos taisyti arba prašyti ištrinti. Susisiekite su mumis per projekto kontaktus.</p>

      <h2 className="text-xl font-semibold mt-4 mb-2">5. Kontaktai</h2>
      <p className="mb-2">Jeigu turite klausimų dėl privatumo, susisiekite paštu <a href="mailto:titas.petrauskas@kitm.lt" className="text-white hover:text-white/90 underline-offset-4 hover:underline">titas.petrauskas@kitm.lt</a></p>
    </main>
  );
}
